import { Box, styled, Typography } from '@mui/material';

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const Text = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;

  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;

  color: #000000;
`;

export const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  .assinados {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #4caf50;
  }
  .pendentes {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #d62237;
  }

  .text {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;

    display: flex;
    align-items: center;
    text-align: center;
    color: #4caf50;
  }

  .desc {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.15px;
    color: #212121;
  }
`;

export const Section = styled(Box)``;

export const CardUser = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0px;
  justify-content: start;
  width: 100%;
  height: 62px;
  border-top: 1px solid #e0e0e0;

  span {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;

export const ContainerSuccess = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 20px;
  gap: 10px;

  width: 100%;
  height: 377px;
`;
export const TextSuccess = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;

  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
`;
